import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";
interface UpdateRecommendationParams {
  recommendationDescription: string;
}

interface UpdateRecommendationResponse {
  references: fhirTypes.DocumentReference[];
}

export const useUpdateRecommendation = ({
  encounterId,
  carePlanId,
  recommendationId,
}: {
  encounterId: string;
  carePlanId: string;
  recommendationId?: string;
}) => {
  const queryClient = useQueryClient();
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApiMutation<
    UpdateRecommendationResponse,
    UpdateRecommendationParams
  >({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Recommendation.UPDATE({
          patientId,
          encounterId,
          carePlanId,
        }),
      mutationFn: (params) => {
        return axiosInstance.patch(
          `/charting/careplan/${carePlanId}/recommendation/${recommendationId}`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Recommendation.DEFAULT(
              {
                patientId,
                encounterId,
                carePlanId,
              },
            ),
        });
      },
    },
  });
};
